import service from './request'
import downloadService from "./downloadRequest.js";

/**
 * 问卷列表
 */
export const questionnaireGetList = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/cfg/getList',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 问卷信息
 */
export const questionnaireGetInfo = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/cfg/getInfo',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 问卷添加
 */
export const questionnaireAddInfo = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/cfg/addInfo',
    method: "post",
    type: 'body',
    data
  })
}

/**
 * 问卷修改
 */
export const questionnaireUpdateInfo = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/cfg/updateInfo',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 问卷删除
 */
export const questionnaireDelInfo = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/cfg/delInfo',
    method: 'post',
    data
  })
}

/**
 * 提交审批
 */
export const questionnaireApplyInfo = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/cfg/applyInfo',
    method: 'post',
    data
  })
}

/**
 * 问卷发布
 */
 export const questionnairePublishInfo = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/cfg/publishInfo',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 问卷完成提示配置
 */
 export const questionnaireTipsCfg = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/cfg/tipsCfg',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 待审批列表
 */
 export const checkGetList = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/check/getList',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 问卷审批
 */
 export const checkInfo = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/check/checkInfo',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 问卷题目列表
 */
 export const questionGetList = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/question/cfg/getList',
    method: 'post',
    data
  })
}

/**
 * 问卷题目保存
 */
 export const questionSaveInfo = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/question/cfg/saveInfo',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 问卷题目删除
 */
 export const questionDelInfo = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/question/cfg/delInfo',
    method: 'post',
    data
  })
}

/**
 * 调查问卷信息 - 应用 - 内部
 */
 export const useApiGetInfo = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/useApi/getInfo',
    method: 'post',
    newVdnId: true, //外部应用接口增加配置项
    data
  })
}

/**
 * 调查问卷题目信息 - 应用 - 内部
 */
 export const useApiGetQuestionList = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/useApi/getQuestionList',
    method: 'post',
    newVdnId: true, //外部应用接口增加配置项
    data
  })
}

/**
 * 调查问卷信息 - 应用 - 外部 - 有校验是否发布过期
 */
 export const useApiGetInfo4App = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/useApi/getInfo4App',
    method: 'post',
    newVdnId: true, //外部应用接口增加配置项
    data
  })
}

/**
 * 调查问卷题目信息 - 应用 - 外部 - 有校验是否发布过期
 */
 export const useApiGetQuestionList4App = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/useApi/getQuestionList4App',
    method: 'post',
    newVdnId: true, //外部应用接口增加配置项
    data
  })
}

/**
 * 调查问卷填写保存 - 应用
 */
 export const useApiSaveInfo = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/useApi/saveInfo',
    method: 'post',
    newVdnId: true, //外部应用接口增加配置项
    type: 'body',
    data
  })
}

/**
 * 调查问卷结果列表
 */
 export const resultViewGetList = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/rpt/resultView/getList',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 调查问卷结果详情
 */
 export const resultViewGetInfo = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/rpt/resultView/getInfo',
    method: 'post',
    data
  })
}

/**
 * 保存问卷题目seq
 */
 export const saveSeq = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/question/cfg/saveSeq',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 坐席工作量统计报表
 */
 export const agentWorkloadTotal = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/rpt/agentWorkload/total',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 选项占比报表
 */
 export const qsOptionTotal = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/rpt/qsOption/total',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 问卷任务统计报表
 */
 export const questionnaireTaskTotal = data => {
  return service({
    showLoading: false,
    url: '/platform/questionnaire/rpt/questionnaireTask/total',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 坐席工作量统计报表 - 导出
 */
 export const agentWorkloadTotalExport = data => {
  return downloadService({
    showLoading: false,
    url: '/platform/questionnaire/rpt/agentWorkload/total/export',
    method: 'post',
    type: 'body',
    responseType: "blob",
    data
  })
}

/**
 * 选项占比报表
 */
 export const qsOptionTotalExport = data => {
  return downloadService({
    showLoading: false,
    url: '/platform/questionnaire/rpt/qsOption/total/export',
    method: 'post',
    type: 'body',
    responseType: "blob",
    data
  })
}

/**
 * 问卷任务统计报表
 */
 export const questionnaireTaskTotalExport = data => {
  return downloadService({
    showLoading: false,
    url: '/platform/questionnaire/rpt/questionnaireTask/total/export',
    method: 'post',
    type: 'body',
    responseType: "blob",
    data
  })
}




// WEBPACK FOOTER //
// ./src/http/Questionnaire.js